import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "@navigation";

export function useSafeNavigation(
  delayedRoutes: string[] = [
    `${ROUTES.UNITS}/${ROUTES.ALL}`,
    `${ROUTES.UNITS}/${ROUTES.UNITDESCRIPTION}`,
    ROUTES.CUSTOMERS,
  ],
) {
  const navigate = useNavigate();
  const location = useLocation();
  const [navigating, setNavigating] = useState(false);
  const prevPathRef = useRef(location.pathname);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (prevPathRef.current !== location.pathname) {
      prevPathRef.current = location.pathname;
      setNavigating(false);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    }
  }, [location.pathname]);

  const safeNavigate = (path: string) => {
    const isDelayed = delayedRoutes.some((route) => path.includes(route));
    if (path !== location.pathname && isDelayed) {
      setNavigating(true);
    }
    navigate(path);
  };

  return { safeNavigate, navigating, location };
}
